const storageFilters = {
  unit: true,
  attendance: true,
  client: true,
  ratedIn: true,
  response: true,
  profile: true,
  note: true,
  os: true,
  attendant: true,
  status: true,
};

//const initialState = storageFilters;
const initialState = localStorage.getItem("filters_nps_dealing_columns")
  ? JSON.parse(localStorage.getItem("filters_nps_dealing_columns"))
  : storageFilters;

const columnsDealing = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGE_COLUMNS_DEALING":
      return {
        unit: action.unit,
        attendance: action.attendance,
        client: action.client,
        ratedIn: action.ratedIn,
        response: action.response,
        profile: action.profile,
        note: action.note,
        os: action.os,
        attendant: action.attendant,
        status: action.status,
      };
    default:
      return state;
  }
};

export default columnsDealing;
